export const getOnlineFlag = () => {
  return navigator.onLine;
};
